
// GreenSock Animation Platform
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);


// Throttle
import { throttle } from 'lodash'
window._throttle = throttle

// Toggle classes on the root element
window.docToggle = (className, value) => document.documentElement.classList.toggle( className, value )

// Scroll detection for the header
let lastScrollY = window.scrollY

window.addEventListener('scroll', ()=>{
	docToggle( 'scroll--top', window.scrollY < 10 )
	docToggle( 'scroll--up', window.scrollY < lastScrollY )

	if( window.scrollY > lastScrollY && window.innerWidth > 560 ){
		docToggle( 'menu--open', false )
	}

	lastScrollY = window.scrollY
})

// Smooth "Back to top" links
window.addEventListener('click', e =>{
	if( !e.target.matches('a[href="#top"]') ){ return }
	e.preventDefault()

	gsap.to(window, { duration: .4, scrollTo: 0 })
})

// Subscribe form
let subscribe 	= document.body.querySelector('.site--footer .subscribe')
let form 		= subscribe.querySelector('form')
let success 	= subscribe.querySelector('.success')

subscribe.addEventListener('submit', e =>{
	e.preventDefault()

	if( subscribe.classList.contains('is--loading') ) return
	subscribe.classList.add('is--loading')
	success.hidden = true

	fetch( form.action, {
		method: form.method,
		headers: { 'X-Requested-With': 'XMLHttpRequest' },
		body: new FormData(form),

	} ).then(()=>{
		subscribe.classList.remove('is--loading')
		success.hidden = false
		form.reset()
	})
})


// Algolia search
import algoliasearch from "algoliasearch"
parallax.algolia.client = algoliasearch( parallax.algolia.app, parallax.algolia.key ).initIndex( parallax.algolia.index )

// Alpine.js
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import partialListing from "./alpine/partial-listing";

Alpine.plugin(collapse)
window.Alpine = Alpine
Alpine.data("partiallisting", partialListing);
Alpine.start()


// Barba.js
require('./barba')
